import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import { useTheme } from '@mui/material/styles';

export type SearchQueryProps = {
  query: string;
  clearSearchHandler: () => void;
};
export default function SearchQuery({
  query,
  clearSearchHandler,
}: SearchQueryProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContet: 'center',
        alignItems: 'center',
        ml: 2,
        borderBottom: '2px solid transparent',
        borderImage: `${theme.palette.primary.vertical}`,
        borderImageSlice: 1,
      }}
    >
      <Typography variant="subtitle1">Search: &quot;{query}&quot;</Typography>
      <IconButton
        sx={{ width: 24, height: 24, ml: 4 }}
        onClick={clearSearchHandler}
      >
        <GradientIcon IconComponent={CloseIcon} />
      </IconButton>
    </Box>
  );
}
